<template>
  <div>
    <input
      type="text"
      class="col-11"
      @change=getVariants
      v-model="name"
      style="border-bottom: 1px solid #dddddd;margin-left: -10px;"
      placeholder="Search hotels in beds"
    />
    <img src="@/assets/svg/refresh-ccw.svg" alt="loading" v-show="showLoading" class="rotating">
    <div v-if="variants.length">
      <br />
      <div v-for="(variant, variantIndex) in variants"
        :key="variantIndex"
      >
        <label class="row">
          <input class="col-1" type="radio" name="variant" @change=setHotel :value=variant.code :data-name=variant.name />
          <span class="col">{{ variant.name + ' (' + variant.countryCode + ', ' + variant.city + ')' }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Beds from '@/services/hatsApi/Beds'

export default {
  props: {
    value: {
      type: Number
    },
    entity: {
      type: [Object]
    }
  },
  data () {
    return {
      name: '',
      showLoading: false,
      variants: []
    }
  },
  async created () {
    if (parseInt(this.value)) {
      let filters = [
        {
          property: 'code',
          value: this.value
        }
      ]
      let response = await Beds.getHotels(filters)
      if (response.data.success) {
        this.name = response.data.data[0].name
      }
    }
  },
  methods: {
    async getVariants () {
      let filters = [
        {
          property: 'name',
          value: this.name
        }
      ]
      this.showLoading = true
      let response = await Beds.getHotels(filters)
      if (response.data.success) {
        this.variants = response.data.data
        this.showLoading = false
      }
    },
    setHotel (event) {
      this.entity.bedsHotelCode = this.value = event.target.value
      this.name = event.target.dataset.name
      this.variants = []
    }
  },
  watch: {
    'name': {
      handler () {
        if (!this.name) {
          this.entity.bedsHotelCode = this.value = null
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/BedsHotelSearcher.vue